export enum SubscriptionLogicEnum {
  FIXED = 'FIXED',
  COUNT_USERS_LOCKS = 'COUNT_USERS_LOCKS',
  COUNT_LOCKS = 'COUNT_LOCKS',
  COUNT_ELEMENTS = 'COUNT_ELEMENTS'
};